import React from 'react';
import {request} from '../helpers/request'
import {isLoggedIn} from '../helpers/access'
import jQuery from 'jquery'
import ModalComponent from './common/ModalComponent'
import LoadingComponent from './common/LoadingComponent'
import {browserHistory} from 'react-router'
import {getPwdError} from '../helpers/common'
import {t} from '../helpers/translate'
import PasswordComponent from './common/PasswordComponent';
let config = require('config');

class Reset extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token: this.props.params.token,
      password: '',
      confirm: '',
      hasError: false,
      errorMessage: '',
      showModal: false,
      processing: false
    };
    if (isLoggedIn()) {
      window.location.pathname = '/sources'
    }
  }

  handlePasswordChange(value) {
    this.setState({password: value})
  }

  handleConfirmChange(value) {
    this.setState({confirm: value})
  }

  submitPasswordUpdateRequest() {
    if(this.invalidPassword()) {
      this.setState({
        hasError: true,
        errorMessage: this.invalidPassword()
      })
    } else {
      this.setState({processing: true})
      this.sendPasswordUpdateRequest()
    }
  }

  sendPasswordUpdateRequest () {
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/auth/forgotpassword/complete`,
        method: 'POST',
        data: {
          token: this.props.params.token,
          password: this.state.password
        }
      }
    ).always((response, statusText) => {
      this.state.processing = false;
      if (statusText == 'success') {
        this.setState({
          hasError: false,
          showModal: true,
        })
      } else {
        this.setState({
          hasError: true,
          errorMessage: 'Your password request update was unsuccessful'
        })
      }
    });
  }

  verifyPasswordResetToken() {
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/auth/forgotpassword/verify`,
        method: 'POST',
        data: {
          token: this.state.token
        }
      }
    ).always((response, statusText) => {
      if (statusText == 'success' && !response.valid) {
        this.showInvalidTokenError()
      } else {
        this.showInvalidTokenError()
      }
    });
  }

  showInvalidTokenError () {
    this.setState({
      hasError: true,
      errorMessage: t('Your password reset link is invalid'),
      token: false
    })
  }

  invalidPassword () {
    return getPwdError(this.state.password, this.state.confirm);
  }

  getPasswordResetModalBody () {
    return <span> {t('Your password has been updated')} </span>
  }

  handleModalClose() {
    this.setState({
      showModal: false
    }, this.redirectUserToHome())
  }

  redirectUserToHome () {
    window.location.pathname = '/login';
  }

  render() {
    return (
      <div className="container div-center">
        <div className="text-center bg-inherit">
          <h1>{t("Password Reset")}</h1>
        </div>
        {this.state.token ? (
          <div
            className={`form-group-lg ${
              this.state.hasError ? "has-error" : ""
            }`}
          >
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <PasswordComponent
                  type="reset"
                  placeholder={"New Password"}
                  editMode
                  onDataChanged={({ target, value }) => {
                    this.handlePasswordChange(value);
                  }}
                />
                <PasswordComponent
                  type="reset"
                  placeholder={"Confirm Password"}
                  editMode
                  onDataChanged={({ target, value }) => {
                    this.handleConfirmChange(value);
                  }}
                />
                </div>
            </div>
            <br />
            {this.state.hasError ? (
              <h4 className="cancellation-error">{this.state.errorMessage}</h4>
            ) : null}
            <button
              onClick={this.submitPasswordUpdateRequest.bind(this)}
              type="button"
              className="btn btn-lg button-primary center-block"
            >
              {t("Submit")}
            </button>
            <br />
            <ModalComponent
              title={t("Password Updated")}
              body={this.getPasswordResetModalBody()}
              onClose={this.handleModalClose.bind(this)}
              show={this.state.showModal}
            />
            <LoadingComponent
              show={this.state.processing}
              text="Processing Request"
            />
          </div>
        ) : (
          <span>{this.state.errorMessage}</span>
        )}
      </div>
    );
  }
}

Reset.defaultProps = {};

export default Reset;



// WEBPACK FOOTER //
// ./src/components/Reset.js